import { BOOKING_HISTORY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  bookingHistories: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const bookingHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOOKING_HISTORY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case BOOKING_HISTORY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        bookingHistories: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case BOOKING_HISTORY.FAIL: {
      return { state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default bookingHistoryReducer;
